<template>
  <div>
    <q-dialog :visible="visible" title="回退" width="50%" :innerScroll="false" @confirm="confirm" @cancel="onCancel" :loading="loadingBtn" @close="onCancel">
      <div v-loading="loading" class="content">
        <div class="header">
          <div style="display: flex; align-items: center">
            <span class="labelText">回退规则：</span>
            <el-popover placement="right-start" title="" width="500" trigger="click">
              <div class="popoverBOx">
                <p>1、回退节点说明:设计、切片请选择“SKU"进行回退;拍摄、修片、修片/模特图、仅模特图(修片)和渲染请选择”产品”进行回退;</p>
                <p>2、回退操作说明:选择节点回退后，后续节点都需重新走节点流程;</p>
                <p>3、修片、渲染回退说明:选择产品名称回退后，涉及到SKU都将回退，回退后重新上传只需上传回退产品即可:</p>
              </div>
              <el-button type="text" slot="reference">点击查看</el-button>
            </el-popover>
          </div>
          <div>
            <el-button class="green-btn" size="mini" @click="getFallbackList">查看回退记录</el-button>
          </div>
        </div>
        <div>
          <el-form :model="form" size="small" :rules="rules" ref="ruleForm" label-width="80px">
            <el-form-item label="回退节点" prop="backProcess">
              <el-select v-model="form.backProcess" @change="backProcessChange">
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in ['拍摄', '修片', '修片和模特图', '仅模特图(修片)', '切片', '渲染']"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退回原因" prop="backReason">
              <el-select v-model="form.backReason" @change="backReasonChange">
                <el-option :label="item" :value="item" v-for="(item, index) in backReasonList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="backRemark">
              <el-input type="textarea" style="width: 100%" v-model="form.backRemark" :autosize="{ minRows: 4, maxRows: 6 }"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="redTips" v-if="isShowType">注:选择产品名称回退后，涉及到SKU都将回退，回退后重新上传只需上传回退产品即可;</div>
        <el-table
          :data="skuData.list"
          v-if="tableReload"
          border
          @selection-change="handleSelectionChange"
          height="320px"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          :row-key="
            (row) => {
              return row.orderCode;
            }
          "
          style="width: 100%"
        >
          <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column>
          <el-table-column :prop="item.prop" :label="item.label" v-for="item in cloumnList" :key="item.prop" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 20px" v-if="isShowType">
          <el-pagination
            @size-change="skuSizeChange"
            @current-change="skuCurrentChange"
            :current-page="skuData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="skuData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="skuData.total"
          >
          </el-pagination>
        </div>
      </div>
    </q-dialog>
    <!-- 回退记录 -->
    <q-dialog :visible="isVisibleRecord" v-if="isVisibleRecord" title="回退记录" width="80%" :innerScroll="false" :showFooter="false" @close="onCancelRecord">
      <div v-loading="loading2" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <el-table :data="recordData.list" border highlight-current-row height="320px" style="width: 100%">
          <el-table-column prop="skuCode" label="回退SKU编码" width="150"> </el-table-column>
          <el-table-column prop="skuName" label="回退SKU名称" width="220" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="productCode" label="回退产品编码" width="130"> </el-table-column>
          <el-table-column prop="productName" label="回退产品名称" width="220" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="backProcess" label="回退节点" width="80"> </el-table-column>
          <el-table-column prop="backReason" label="回退原因" width="110"> </el-table-column>
          <el-table-column prop="userName" label="操作人" width="80"> </el-table-column>
          <el-table-column prop="creationDate" label="操作时间" width="160"> </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 20px">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="recordData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="recordData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordData.total"
          >
          </el-pagination>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancelRecord" size="medium">关 闭</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'up',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    skuList: {
      type: Array,
      default: [],
    },
    spuId: [String, Number],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    backReasonList() {
      return this.form.backProcess == '设计' || this.form.backProcess == '切片' ? ['工艺色差调整', '尺寸调整', '材质调整','卖点调整','新增内容','其他'] : ['改工艺', '改色差', '补图', '其它'];
    },
    isShowType() {
      let typeList = ['设计', '切片'];
      return this.form.backProcess && !typeList.includes(this.form.backProcess);
    },
    cloumnList() {
      if (this.isShowType) {
        return [
          { prop: 'productName', label: '产品名称' },
          // { prop: 'skuName', label: '涉及SKU名称' },
          { prop: 'productCode', label: '产品编码' },
        ];
      } else {
        return [
          { prop: 'skuCode', label: 'SKU编码' },
          { prop: 'skuName', label: 'SKU名称' },
          { prop: 'taskName', label: 'SKU进度' },
        ];
      }
    },
  },
  data() {
    return {
      loading: false,
      loading2: false,
      loadingBtn: false,
      isVisibleRecord: false,
      addForm: {
        dataType: 2,
      },
      rules: {},
      addForm: {},
      storeList: [],
      tableData: [],
      recordData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      skuData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      onRemoveSpuIds: [],
      selectSpus: [],
      productList: [],
      form: {
        backProcess: '',
        renderFlag: 'N',
        modelFlag: 'N',
        backReason: '',
        backRemark: '',
      },
      rules: {
        backProcess: [{ required: true, message: '不能为空', trigger: 'change' }],
        backReason: [{ required: true, message: '不能为空', trigger: 'change' }],
        backRemark: [{ required: false, message: '不能为空', trigger: 'blur' }],
      },
      typeData: {},
    };
  },
  methods: {
    onCancelRecord() {
      this.isVisibleRecord = false;
    },
    onCancel() {
      this.$refs.ruleForm.resetFields();
      this.isVisible = false;
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        console.log("🚀 ~ confirm ~ this.selectSpus:", !this.selectSpus.length)
        if (!valid || !this.selectSpus.length) return;
        this.loadingBtn = true
        let data = {
          ...this.form,
          spuId: this.spuId,
          skuCodeList: !this.isShowType ? this.selectSpus.map((v) => v.skuCode) : [],
          skuCodeAndProductList: this.isShowType
            ? this.selectSpus.map(({ productCode, skuCode }) => {
                return { productCode, skuCode };
              })
            : [],
        };
        this.$q.newProduct.processRollback({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success('回退成功');
            this.onCancel();
            this.$emit('success');
          }
        }).finally(_=>{
          this.loadingBtn = false
        });
      })
    },
    edit() {
      if (!this.selectSpus.length) {
        this.$message.error('请选择后在进行操作！');
        return;
      }
      this.isVisible = true;
    },
    handleSelectionChange(val) {
      this.selectSpus = val;
    },
    backProcessChange(val) {
      if (this.isShowType) {
        this.queryRetouchRollBackProduct()
      } else {
        this.skuData.list = [...this.skuList]
      }
    },
    backReasonChange(val) {
      if (val == '其它') {
        this.rules.backRemark[0].required = true;
      } else {
        this.rules.backRemark[0].required = false;
        this.$refs.ruleForm.clearValidate(['backRemark']);
      }
    },
    //获取 isShowType为false的其他回退节点 产品维度的数据
    queryRetouchRollBackProduct() {
      this.loading = true;
      let backProcess = this.form.backProcess
      let data = {
        filterData: {
          spuId: this.spuId,
          taskId: backProcess == '拍摄' ? 1 : backProcess == '修片' ? 2 : backProcess == '修片和模特图' ? 3 : backProcess == '仅模特图(修片)' ? 4 : 5,
        },
        pageNum: this.skuData.pageNum,
        pageSize: this.skuData.pageSize,
      };
      this.$q.newProduct
        .queryRetouchRollBackProduct({ data })
        .then(({ data }) => {
          this.skuData.list = data.list
          this.skuData.total = data.total;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    skuSizeChange(pageSize) {
      this.skudData.pageSize = pageSize;
      this.pageTure = true;
      this.queryRetouchRollBackProduct();
    },
    skuCurrentChange(pageNum) {
      this.skuData.pageNum = pageNum;
      this.pageTure = true;
      this.queryRetouchRollBackProduct();
    },
    onSizeChange(pageSize) {
      this.recordData.pageSize = pageSize;
      this.pageTure = true;
      this.productBackRecordPage();
    },
    onCurrentChange(pageNum) {
      this.recordData.pageNum = pageNum;
      this.pageTure = true;
      this.productBackRecordPage();
    },
    getFallbackList() {
      this.isVisibleRecord = true;
      this.productBackRecordPage();
    },
    //获取回退记录列表信息
    productBackRecordPage() {
      this.loading2 = true;
      let data = {
        filterData: this.spuId,
        pageNum: this.recordData.pageNum,
        pageSize: this.recordData.pageSize,
      };
      this.$q.newProduct
        .productBackRecordPage({ data: data })
        .then((res) => {
          if (res.success) {
            this.recordData = res.data;
          }
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    // // 遍历表格数据，计算合并行数据
    // computeSpanData(list) {
    //   this.spanArr = [];
    //   list.forEach((item, index) => {
    //     this.recordSpanData(index, list);
    //   });
    // },
    // // 计算每一行的合并行数据
    // recordSpanData(index, data) {
    //   if (index === 0) {
    //     this.spanArr.push(1);
    //     this.spanIndex = 0;
    //   } else {
    //     // 判断当前元素与上一个元素是否相同
    //     if (data[index].productName === data[index - 1].productName) {
    //       this.spanArr[this.spanIndex] += 1;
    //       this.spanArr.push(0);
    //     } else {
    //       this.spanArr.push(1);
    //       this.spanIndex = index;
    //     }
    //   }
    // },
    // objectSpanMethod({ rowIndex, columnIndex }) {
    //   if (columnIndex == 1 && this.isShowType) {
    //     return {
    //       rowspan: this.spanArr[rowIndex],
    //       colspan: 1,
    //     };
          
    //   }
    // },
  },
  mounted() {
    this.skuData.list = [...this.skuList];
    // this.queryRetouchRollBackProduct();
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px
}

.content {
  max-height: 70vh
  overflow-y: auto
}

.labelText {
  display: block
  width: 80px
  text-align: right
}

.redTips {
  color: red
  margin-bottom: 10px
}

>>> .el-dialog {
  margin-top: 50px !important
}
</style>
